import { isSome } from '../../util'

// 明細番号（rank）は明細順であってページ番号ではないため、ページの根拠にしない。
// 原本が複数あると pageNumber がどの原本のページか分からず、1ページ目の推定も別の原本を指しうるので、
// 原本がちょうど1件のときだけページを特定する。
export function resolveMillsheetPdfPage({
  pageNumber,
  originals,
}: {
  pageNumber: number | null | undefined
  originals: ReadonlyArray<{ thumbnailCount: number | null | undefined }>
}): number | null {
  const [original, ...rest] = originals
  if (!isSome(original) || rest.length > 0) {
    return null
  }
  if (isSome(pageNumber)) {
    return pageNumber
  }
  return original.thumbnailCount === 1 ? 1 : null
}
